var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isRubetek)?_c('SoundSetupRubetek'):_c('AnalogLineBeward',{attrs:{"doorphone":this.doorphoneEditInfo.doorphone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }